import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Alert } from "@mui/material";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { TextField } from "@mui/material";
import ScenarioSelector from "./ScenarioSelector";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

export default function NewRecipe(props) {
  const [saveDisabled, setSaveDisabled] = React.useState(true);
  const [errors, setErrors] = React.useState({
    recipeExistsError: "",
  });
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);
  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [selectedScenarios, setSelectedScenarios] = React.useState([]);

  const clearForm = () => {
    setTitle("");
    setDescription("");
    setSelectedScenarios([]);
  };

  useEffect(() => {
    if (!(title === "" || description === "")) {
      setSaveDisabled(false);
    } else {
      setSaveDisabled(true);
    }
  }, [title, description, selectedScenarios]);

  const handleSubmitNewUser = (e) => {
    const formData = { title, description, scenarios: selectedScenarios };

    e.preventDefault();
    setSaveDisabled(true);

    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/recipe/add",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(formData),
      }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Unable to access endpoint: recipe/add");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data < 0) {
          setErrors({ recipeExistsError: "Der Titel ist bereits vergeben." });
        } else {
          clearForm();
          props.setRows((prev) =>
            prev.concat([
              {
                id: data,
                title: title,
                description: description,
                scenarios: selectedScenarios,
              },
            ])
          );
          setGlobalMessage({
            globalMessage: "Rezeptur angelegt",
            severity: "success",
          });
        }
        setGlobalMessage({
          globalMessage: "Rezeptur angelegt",
          severity: "success",
        });
      })
      .catch((error) => {
        setGlobalMessage({
          globalMessage: "Vorgang fehlgeschlagen",
          severity: "error",
        });
      })
      .finally(() => setSaveDisabled(false));
  };

  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)}>
      <Box component="form" onSubmit={(e) => handleSubmitNewUser(e)}>
        <DialogTitle>Neue Rezeptur anlegen</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="newRecipeTitle"
            label="Titel"
            type="text"
            fullWidth
            variant="standard"
            required
            value={title}
            onInput={(e) => {
              setTitle(e.target.value);
            }}
          />
          <TextField
            sx={{ mb: 3 }}
            multiline
            margin="dense"
            id="newRecipeDescription"
            label="Beschreibung"
            type="text"
            fullWidth
            variant="standard"
            required
            value={description}
            onInput={(e) => {
              setDescription(e.target.value);
            }}
          />

          {
            //TODO state management
          }
          <ScenarioSelector
            width="100%"
            selectedScenarios={selectedScenarios}
            setSelectedScenarios={setSelectedScenarios}
          />

          {errors.recipeExistsError && (
            <Alert sx={{ mt: 3 }} variant="outlined" severity="error">
              <ul style={{ margin: 0 }}>
                {errors.recipeExistsError && (
                  <li key="recipeExistsError">{errors.recipeExistsError}</li>
                )}
              </ul>
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.setOpen(false)}>Schließen</Button>
          <Button onClick={() => clearForm()}>Formular leeren</Button>
          <Button type="submit" disabled={saveDisabled}>
            Hinzufügen
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
